"use strict";
// Colors
let graya = 'rgba(200,200,200,0.5)';
let greena = 'rgba(200,255,200,0.7)';

//Language
var url = window.location.href;
if(url.indexOf("/en/") !== -1) {
    var lang = "en";
} else {
    var lang = "de";
}

var config = {
    modeBarButtonsToRemove: [
        'sendDataToCloud',
        'toImage',
        'select2d',
        'lasso2d',
        'autoscale2d',
        'hoverClosestCartesian',
        'hoverCompareCartesian',
        'autoScale2d',
        'toggleSpikelines',
    ],
    responsive: true,
    displaylogo: false,
};

// Model Parameters
var phi = 0.0;
var phi_princ = 0;

let sigmax, sigmaz, tauxz;

// Define Drawing parameters
let arrow_scale = 0.5;
let arrow_head_length = 0.4; // value manually extracted from on draw.lib
let arrow_length_scale = 0.2;
let gap = 0.1;

/*
Draw conventions
 */
let arrowlength = 0.5 + arrow_scale * arrow_head_length;
let temp_conventions = new Group();

// Physical element
let x_physical = -2
if(lang == "en") {
    temp_conventions.addElm(new Text(x_physical, 1.75, "Physical space"));
} else {
    temp_conventions.addElm(new Text(x_physical, 1.75, "Physikalische Ebene"));
}

temp_conventions.addElm(new Rectangle(1, 1, x_physical, 0).setFill(graya));

temp_conventions.addElm(new Arrow(x_physical + 0.5 + gap, 0, arrowlength, 0, arrow_scale).rotate(-90, x_physical + 0.5 + gap, 0).rotate(180, x_physical + 0.5 + gap + arrowlength / 2, 0).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_physical - (0.5 + gap), 0, arrowlength, 0, arrow_scale).rotate(90, x_physical - (0.5 + gap), 0).rotate(180, x_physical - (0.5 + gap + arrowlength / 2), 0).setColor(col.base.getRgb()).setFill(col.base.getRgba()));

temp_conventions.addElm(new Arrow(x_physical, -(0.5 + gap + arrowlength), arrowlength, 0, arrow_scale).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_physical, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(180, x_physical, (0.5 + gap + arrowlength / 2)).setColor(col.base.getRgb()).setFill(col.base.getRgba()));

temp_conventions.addElm(new Arrow(x_physical + 0.5 + gap, -arrowlength / 2, arrowlength, 0, arrow_scale).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_physical - (0.5 + gap), -arrowlength / 2, arrowlength, 0, arrow_scale).rotate(180, x_physical - (0.5 + gap), 0).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_physical + arrowlength / 2, -(0.5 + gap), arrowlength, 0, arrow_scale).rotate(90, x_physical + arrowlength / 2, -(0.5 + gap)).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_physical - arrowlength / 2, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(-90, x_physical - arrowlength / 2, (0.5 + gap)).setColor(col.base.getRgb()).setFill(col.base.getRgba()));

temp_conventions.addElm(new Arrow(x_physical, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(90, x_physical, 0));
temp_conventions.addElm(new Arrow(x_physical, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()));
temp_conventions.addElm(new Text(x_physical + 0.25, 0.15, "<i>x</i>"));
temp_conventions.addElm(new Text(x_physical - 0.15, -0.25, "<i>z</i>"));

// Mohr element
let x_mohr = 2
if(lang == "en") {
    temp_conventions.addElm(new Text(x_mohr, 1.75, "Mohr's space"));
} else {
    temp_conventions.addElm(new Text(x_mohr, 1.75, "MOHRsche Ebene"));
}

temp_conventions.addElm(new Rectangle(1, 1, x_mohr, 0).setFill(graya));

temp_conventions.addElm(new Arrow(x_mohr + 0.5 + gap, 0, arrowlength, 0, arrow_scale).rotate(-90, x_mohr + 0.5 + gap, 0).rotate(180, x_mohr + 0.5 + gap + arrowlength / 2, 0).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_mohr - (0.5 + gap), 0, arrowlength, 0, arrow_scale).rotate(90, x_mohr - (0.5 + gap), 0).rotate(180, x_mohr - (0.5 + gap + arrowlength / 2), 0).setColor(col.base.getRgb()).setFill(col.base.getRgba()));

temp_conventions.addElm(new Arrow(x_mohr, -(0.5 + gap + arrowlength), arrowlength, 0, arrow_scale).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_mohr, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(180, x_mohr, (0.5 + gap + arrowlength / 2)).setColor(col.base.getRgb()).setFill(col.base.getRgba()));

temp_conventions.addElm(new Arrow(x_mohr + 0.5 + gap, -arrowlength / 2, arrowlength, 0, arrow_scale).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_mohr - (0.5 + gap), -arrowlength / 2, arrowlength, 0, arrow_scale).rotate(180, x_mohr - (0.5 + gap), 0).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_mohr + arrowlength / 2, -(0.5 + gap), arrowlength, 0, arrow_scale).rotate(90, x_mohr + arrowlength / 2, -(0.5 + gap)).rotate(180, x_mohr, -(0.5 + gap)).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
temp_conventions.addElm(new Arrow(x_mohr - arrowlength / 2, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(-90, x_mohr - arrowlength / 2, (0.5 + gap)).rotate(180, x_mohr, (0.5 + gap)).setColor(col.base.getRgb()).setFill(col.base.getRgba()));

temp_conventions.addElm(new Arrow(x_mohr, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(90, x_mohr, 0));
temp_conventions.addElm(new Arrow(x_mohr, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()));
temp_conventions.addElm(new Text(x_mohr + 0.25, 0.15, "<i>x</i>"));
temp_conventions.addElm(new Text(x_mohr - 0.15, -0.25, "<i>z</i>"));


let layout_conventions = {
    hovermode: false,
    //width: 400,
    height: 156,
    autosize: true,
    margin: {
        l: 0,
        r: 0,
        b: 0,
        t: 0,
        pad: 0
    },
    xaxis: {
        domain: [0, 1],
        autorange: true,
        showgrid: false,
        zeroline: false,
        showline: false,
        autotick: true,
        ticks: '',
        showticklabels: false,
    },
    yaxis: {
        domain: [0, 1],
        rangemode: 'tozero',
        autorange: true,
        showgrid: false,
        zeroline: false,
        showline: false,
        autotick: true,
        ticks: '',
        showticklabels: false,
        scaleanchor: "x",
        scaleratio: 1,
    },
    showlegend: false,
};
let pltSec = temp_conventions.getPlotData();
var data = pltSec.data;
Plotly.newPlot(plot_conventions, data, layout_conventions, { staticPlot: true, responsive: true, displaylogo: false });



var sliderPhi = document.getElementById('sliderPhi');
noUiSlider.create(sliderPhi, {
    start: [0],
    range: {
        'min': [-90],
        'max': [90]
    },
    tooltips: false,
    step: 0.1,
    pips: {
        mode: 'count',
        values: 7,
        density: 30
    },
    format: wNumb({
        decimals: 1,
    })
});

sliderPhi.noUiSlider.on('update', function () {
    phi = sliderPhi.noUiSlider.get();

    $("#formPhi").val(phi);
    updateCalc();

});

sliderPhi.noUiSlider.on('slide', function () {
    $("#formPhi").val(sliderPhi.noUiSlider.get());
});


$("#formPhi").change(function () {

    let phi_old = phi;
    phi = parseFloat($("#formPhi").val());
    if (isNaN(phi)) {
        phi = phi_old;
        document.getElementById('formPhi').classList.add('is-invalid');
        document.getElementById('Ctrl').classList.add('focus');
        setTimeout(function () {
            alert(["Die Eingabe ist keine Zahl."]);
            document.getElementById('formPhi').classList.remove('is-invalid');
            document.getElementById('Ctrl').classList.remove('focus');
            $("#formPhi").val(phi);
        }, 10)
        return
    } else {
        phi = parseFloat($("#formPhi").val())

        if (phi < -90 || phi > 90) {
            if(lang == "en") {
                alert(["The angle φ must be between -90 and 90°. \nThe value for φ has been adjusted."]);
            } else {
                alert(["Der Winkel φ muss zwischen -90 und 90° liegen. \nDer Wert für  φ wurde angepasst."]);
            }

            if (phi < -90) { phi = -90 }
            if (phi > 90) { phi = 90 }
            $("#formPhi").val(phi);
        }
        sliderPhi.noUiSlider.set(phi)
    }
});


$('#principal').on('click', function () {
    phi = principledir();
    phi_princ = 1;

    sliderPhi.noUiSlider.set([phi])
    $("#formPhi").val(math.round(phi * 100) / 100);

});

$("#sigmax").on("change", function (event) {
    let sigmax_old = sigmax;
    sigmax = parseFloat($("#sigmax").val());
    if (isNaN(sigmax)) {
        sigmax = sigmax_old;
        document.getElementById('sigmax').classList.add('is-invalid');
        document.getElementById('Ctrl').classList.add('focus');
        setTimeout(function () {
            alert(["Die Eingabe ist keine Zahl."]);
            document.getElementById('sigmax').classList.remove('is-invalid');
            document.getElementById('Ctrl').classList.remove('focus');
            $("#sigmax").val(sigmax);
        }, 10)

        return
    }
    updateCalc();
});
$("#sigmaz").on("change", function (event) {
    let sigmaz_old = sigmaz;
    sigmaz = parseFloat($("#sigmaz").val());
    if (isNaN(sigmaz)) {
        sigmaz = sigmaz_old;
        document.getElementById('sigmaz').classList.add('is-invalid');
        document.getElementById('Ctrl').classList.add('focus');
        setTimeout(function () {
            alert(["Die Eingabe ist keine Zahl."]);
            document.getElementById('sigmaz').classList.remove('is-invalid');
            document.getElementById('Ctrl').classList.remove('focus');
            $("#sigmaz").val(sigmaz);
        }, 10)
        return
    }
    updateCalc();
});
$("#tauxz").on("change", function (event) {
    let tauxz_old = tauxz;
    tauxz = parseFloat($("#tauxz").val());
    if (isNaN(tauxz)) {
        tauxz = tauxz_old;
        document.getElementById('tauxz').classList.add('is-invalid');
        document.getElementById('Ctrl').classList.add('focus');
        setTimeout(function () {
            alert(["Die Eingabe ist keine Zahl."]);
            document.getElementById('tauxz').classList.remove('is-invalid');
            document.getElementById('Ctrl').classList.remove('focus');
            $("#tauxz").val(tauxz);
        }, 10)

        return
    }
    updateCalc();
});



$(".updCalc").change(function () {
    updateCalc();
});

function updateCalc() {
    // Get principal direction
    var phi_mohr = phi;
    if (phi_princ == 1) {
        phi = principledir();
    }
    if (phi_mohr == 90) {
        phi_mohr = 89.999;
    }
    if (phi_mohr == -90) {
        phi_mohr = -89.999;
    }




    // Read variables
    sigmax = parseFloat($("#sigmax").val());
    sigmaz = parseFloat($("#sigmaz").val());
    tauxz = parseFloat($("#tauxz").val());
    console.log(sigmax);
    let sigman, sigmat, taunt;
    [sigman, sigmat, taunt] = tensortransform(sigmax, sigmaz, tauxz, phi_mohr);


    let signxz = customsign(tauxz);
    if (signxz == 0) {
        signxz = 1
    }
    let signnt = customsign(taunt);
    if (signnt == 0) {
        signnt = 1
    }

    /*
    Draw Mohr Circle
     */
    let temp_Mohr = new Group();

    // for hovering
    temp_Mohr.addElm(new Line([sigmax, sigmax], [tauxz, -tauxz]).setColor(col.forces.getRgb()));
    temp_Mohr.addElm(new Line([sigmaz, sigmax], [-tauxz, -tauxz]).setColor(col.forces.getRgb()));
    if (phi - 0 !== 0) {
        temp_Mohr.addElm(new Line([sigman, sigmax], [taunt, -tauxz]).setColor(col.sk.getRgb()));
        temp_Mohr.addElm(new Line([sigmat, sigmax], [-taunt, -tauxz]).setColor(col.sk.getRgb()));
    }
    
    let m = (sigmax + sigmaz) / 2; // Centre of Mohr Circle
    let r = math.sqrt(math.pow((sigmax - sigmaz) / 2, 2) + math.pow(tauxz, 2)); // Radius of Mohr Circle
    let markersize = 0.02 * r;
    // transparent line
    temp_Mohr.addElm(new Line([m - r * 1.5, m + r * 1.5], [-r * 1.5, r * 1.5]).setWidth(0));
    temp_Mohr.addElm(new Line([sigmax, sigmax], [-tauxz, -tauxz]).setWidth(0));

    // Circle
    temp_Mohr.addElm(new Circle(m, 0, r));

    // Principal Angle
    temp_Mohr.addElm(new Circle(sigmax, -tauxz, r * 0.3, -phi));
    temp_Mohr.addElm(new Line([sigmax + math.cos(-phi / 180 * math.pi) * r * 0.3, sigmax], [-tauxz + math.sin(-phi / 180 * math.pi) * r * 0.3, -tauxz]).setColor(col.sk.getRgb()).setDash('dot'));
    temp_Mohr.addElm(new Line([sigmax + r * 0.3, sigmax], [-tauxz, -tauxz]).setColor(col.forces.getRgb()).setDash('dot'));
    let phiround = math.round(phi * 10) / 10;


    if (phi == principledir()) {
        temp_Mohr.addElm(new Text(sigmax + math.cos(-phi / 180 / 2 * math.pi) * 0.45 * r + 0.45 * r, -tauxz + math.sin(-phi / 180 / 2 * math.pi) * r * 0.45, [" φ = φ<sub>1</sub> =" + phiround.toString() + "°"]));
    } else {
        temp_Mohr.addElm(new Text(sigmax + math.cos(-phi / 180 / 2 * math.pi) * 0.45 * r + 0.28 * r, -tauxz + math.sin(-phi / 180 / 2 * math.pi) * r * 0.45, [" φ = " + phiround.toString() + "°"]));
    }

    // xz
    temp_Mohr.addElm(new Circle(sigmax, tauxz, markersize).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
    temp_Mohr.addElm(new Circle(sigmaz, -tauxz, markersize).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
    temp_Mohr.addElm(new Support(sigmax, signxz * (math.abs(tauxz) + 0.3 * r), 3, 0.2 * r).rotate(-90, sigmax, signxz * (math.abs(tauxz) + 0.3 * r)));
    temp_Mohr.addElm(new Support(sigmaz + 0.3 * r * customsign(sigmaz - sigmax + 0.000001), -tauxz, 3, 0.2 * r).rotate(180, sigmaz + 0.3 * r * customsign(sigmaz - sigmax + 0.000001), -tauxz));
    if (phi !== 0) {
        temp_Mohr.addElm(new Text(sigmax + customsign(sigmaz - sigmax + 0.000001) * 0.1 * r, tauxz - signxz * 0.1 * r, "<i>X</i>"));
        temp_Mohr.addElm(new Text(sigmaz + customsign(sigmax - sigmaz + 0.000001) * 0.1 * r, -tauxz + signxz * 0.1 * r, "<i>Z</i>"));
    } else if (phi == principledir()) {
        temp_Mohr.addElm(new Text(sigmax + customsign(sigmaz - sigmax + 0.000001) * 0.1 * r, tauxz - signxz * 0.1 * r, "<i>X</i>=1"));
        temp_Mohr.addElm(new Text(sigmaz + customsign(sigmax - sigmaz + 0.000001) * 0.1 * r, -tauxz + signxz * 0.1 * r, "<i>Z</i>=3"));
    }
    else {
        temp_Mohr.addElm(new Text(sigmax + customsign(sigmaz - sigmax + 0.000001) * 0.1 * r, tauxz - signxz * 0.1 * r, "<i>X</i>=<i>N</i>"));
        temp_Mohr.addElm(new Text(sigmaz + customsign(sigmax - sigmaz + 0.000001) * 0.1 * r, -tauxz + signxz * 0.1 * r, "<i>Z</i>=<i>T</i>"));
    }



    // nt
    let d1 = math.distance([sigmax, -tauxz], [sigman, taunt]);
    let d2 = math.distance([sigmax, -tauxz], [sigmat, -taunt]);
    if (phi - 0 !== 0) {
        temp_Mohr.addElm(new Circle(sigman, taunt, markersize).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()));
        temp_Mohr.addElm(new Circle(sigmat, -taunt, markersize).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()));
        temp_Mohr.addElm(new Support(sigmax, -tauxz + signxz * customsign(tauxz + taunt + 0.000001) * (d1 + 0.3 * r), 3, 0.2 * r).rotate(-90 * signxz, sigmax, -tauxz + signxz * customsign(tauxz + taunt + 0.000001) * (d1 + 0.3 * r)).rotate(-phi + (signxz - 1) / 2 * 180, sigmax, -tauxz));
        temp_Mohr.addElm(new Support(sigmax, -tauxz + signxz * -customsign(tauxz - taunt + 0.000001) * (d2 + 0.3 * r), 3, 0.2 * r).rotate(-customsign(math.add(phi, 0.000001)) * 90 * signxz, sigmax, -tauxz + signxz * -customsign(tauxz - taunt + 0.000001) * (d2 + 0.3 * r)).rotate(-phi - customsign(math.add(phi, 0.000001)) * 90 + (signxz - 1) / 2 * 180, sigmax, -tauxz));
    }

    if (phi == 0) {

    }
    else if (phi == principledir()) {
        temp_Mohr.addElm(new Text(sigman + customsign(sigmat - sigman) * 0.1 * r, taunt + signnt * 0.1 * r, "1"));
        temp_Mohr.addElm(new Text(sigmat + customsign(sigman - sigmat) * 0.1 * r, -taunt - signnt * 0.1 * r, "3"));
    }
    else {
        temp_Mohr.addElm(new Text(sigman + customsign(sigmat - sigman) * 0.1 * r, taunt + signnt * 0.1 * r, "<i>N</i>"));
        temp_Mohr.addElm(new Text(sigmat + customsign(sigman - sigmat) * 0.1 * r, -taunt - signnt * 0.1 * r, "<i>T</i>"));
    }

    // Pol
    temp_Mohr.addElm(new Circle(sigmax, -tauxz, markersize).setColor(col.base.getRgb()).setFill(col.base.getRgba()));
    temp_Mohr.addElm(new Text(sigmax - customsign(sigmaz - sigmax) * 0.1 * r, -tauxz - customsign(tauxz) * 0.1 * r, "Q"));

    

    /*
    Draw xz-element
    */
    let maximumvaluesclae = math.divide(3.5, math.max(math.abs(sigmax), math.abs(sigmaz), math.abs(tauxz), 3.5)); // this value avoids arrows drawn outside of the field of view.
    let temp_xzElement = new Group();
    temp_xzElement.addElm(new Rectangle(1, 1, 0, 0).setFill(greena));

    // transparent line
    temp_xzElement.addElm(new Line([-1.5, 1.5], [-1.5, 1.5]).setWidth(0));

    if (sigmax !== 0) {

        let arrowlength = math.abs(sigmax) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;

        // xz-Element
        temp_xzElement.addElm(new Arrow(0.5 + gap, 0, arrowlength, 0, arrow_scale).rotate(-90, 0.5 + gap, 0).rotate((customsign(sigmax) + 1) / 2 * 180, 0.5 + gap + arrowlength / 2, 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_xzElement.addElm(new Arrow(-(0.5 + gap), 0, arrowlength, 0, arrow_scale).rotate(90, -(0.5 + gap), 0).rotate((customsign(sigmax) + 1) / 2 * 180, -(0.5 + gap + arrowlength / 2), 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));

        // Mohr x-Element
        let arroworiginx = (sigmax + gap * 0.4 * r);
        let arroworiginz = signxz * ((math.abs(tauxz) + 0.3 * r));
        temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginz, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r).rotate(-90, arroworiginx, arroworiginz).rotate((customsign(sigmax) + 1) / 2 * 180, arroworiginx + arrowlength * 0.4 * r / 2, arroworiginz).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
    }

    if (sigmaz !== 0) {

        let arrowlength = math.abs(sigmaz) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;

        // xz-Element
        temp_xzElement.addElm(new Arrow(0, -(0.5 + gap + arrowlength), arrowlength, 0, arrow_scale).rotate((customsign(sigmaz) - 1) / 2 * 180, 0, -(0.5 + gap + arrowlength / 2)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_xzElement.addElm(new Arrow(0, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(-(customsign(sigmaz) + 1) / 2 * 180, 0, (0.5 + gap + arrowlength / 2)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));

        // Mohr z-Element
        let arroworiginx = sigmaz + customsign(sigmaz - sigmax + 0.000001) * 0.3 * r;
        let arroworiginz = -tauxz - gap * 0.4 * r - arrowlength * 0.4 * r;
        temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginz, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r).rotate((customsign(sigmaz) - 1) / 2 * 180, arroworiginx, arroworiginz + arrowlength * 0.4 * r / 2).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
    }

    if (tauxz !== 0) {

        let arrowlength = math.abs(tauxz) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;

        // xz-Element
        temp_xzElement.addElm(new Arrow(0.5 + gap, -arrowlength / 2, arrowlength, 0, arrow_scale).rotate(-(signxz - 1) / 2 * 180, 0.5 + gap, 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_xzElement.addElm(new Arrow(-(0.5 + gap), -arrowlength / 2, arrowlength, 0, arrow_scale).rotate(-(signxz + 1) / 2 * 180, -(0.5 + gap), 0).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_xzElement.addElm(new Arrow(arrowlength / 2, -(0.5 + gap), arrowlength, 0, arrow_scale).rotate(90, arrowlength / 2, -(0.5 + gap)).rotate(-(signxz - 1) / 2 * 180, 0, -(0.5 + gap)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
        temp_xzElement.addElm(new Arrow(-arrowlength / 2, (0.5 + gap), arrowlength, 0, arrow_scale).rotate(-90, -arrowlength / 2, (0.5 + gap)).rotate(-(signxz - 1) / 2 * 180, 0, (0.5 + gap)).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));

        // Mohr - x-Element
        let arroworiginx = (sigmax + gap * 0.4 * r);
        let arroworiginz = signxz * ((math.abs(tauxz) + 0.3 * r)) - arrowlength * 0.4 * r / 2;
        temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginz, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r).rotate(-(customsign(tauxz) - 1) / 2 * 180, arroworiginx, arroworiginz + arrowlength * 0.4 * r / 2).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));

        // Mohr - z-Element
        arroworiginx = sigmaz + customsign(sigmaz - sigmax + 0.000001) * 0.3 * r + arrowlength * 0.4 * r / 2;
        arroworiginz = -tauxz - gap * 0.4 * r;
        temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginz, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r).rotate(90, arroworiginx, arroworiginz).rotate(-(signxz - 1) / 2 * 180, arroworiginx - arrowlength * 0.4 * r / 2, arroworiginz).setColor(col.forces.getRgb()).setFill(col.forces.getRgba()));
    }

    // Coordinate System
    temp_xzElement.addElm(new Arrow(0, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(90, 0, 0));
    temp_xzElement.addElm(new Arrow(0, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(0, 0, 0));
    temp_xzElement.addElm(new Text(0.4, 0.1, "<i>x</i>"));
    temp_xzElement.addElm(new Text(0.1, -0.4, "<i>z</i>"));


    /*
    Draw nt-Element
     */
    maximumvaluesclae = math.divide(3.5, math.max(math.abs(sigman), math.abs(sigmat), math.abs(taunt), 3.5)); // this value avoids arrows drawn outside of the field of view.

    let temp_ntElement = new Group();
    temp_ntElement.addElm(new Rectangle(1, 1, 0, 0).setFill(greena).rotate(-phi, 0, 0));

    // transparent line
    temp_ntElement.addElm(new Line([-1.5, 1.5], [-1.5, 1.5]).setWidth(0));


    if (math.abs(sigman) >= 0.005) {

        let arrowlength = math.abs(sigman) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;
        let arroworigin = -customsign(sigman) * (0.5 + gap) - (customsign(sigman) + 1) / 2 * arrow_scale * arrow_head_length * (1 + math.abs(sigman) * maximumvaluesclae);
        let arroworientation = (customsign(sigman) + 1) / 2 * 180 + 90;

        // nt-Element
        temp_ntElement.addElm(new Arrow(0, arroworigin, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi, 0, 0));
        temp_ntElement.addElm(new Arrow(0, arroworigin, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi + 180, 0, 0));

        if (phi - 0 !== 0) {
            // Mohr n-Element
            let arroworiginx = sigmax + customsign(tauxz) * gap * 0.4 * r;
            let arroworiginy = -tauxz + customsign(tauxz) * customsign(tauxz + taunt) * (d1 + 0.3 * r);
            temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginy, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r).rotate((customsign(sigman) + 1) / 2 * 180, arroworiginx, arroworiginy + arrowlength * 0.4 * r / 2).rotate(-90 * customsign(tauxz), arroworiginx, arroworiginy).rotate(-phi + (customsign(tauxz) - 1) / 2 * 180, sigmax, -tauxz).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()));
        }
    }

    if (math.abs(sigmat) >= 0.005) {

        let arrowlength = math.abs(sigmat) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;
        let arroworigin = -customsign(sigmat) * (0.5 + gap) - (customsign(sigmat) + 1) / 2 * arrow_scale * arrow_head_length * (1 + math.abs(sigmat) * maximumvaluesclae);
        let arroworientation = (customsign(sigmat) + 1) / 2 * 180;

        // nt-Element
        temp_ntElement.addElm(new Arrow(0, arroworigin, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi, 0, 0));
        temp_ntElement.addElm(new Arrow(0, arroworigin, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi + 180, 0, 0));

        if (phi - 0 !== 0) {
            // Moor t-Element
            let arroworiginx = sigmax + signxz * customsign(phi) * gap * 0.4 * r;
            let arroworiginy = -tauxz + signxz * -customsign(tauxz - taunt) * (d2 + 0.3 * r)
            temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginy, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r)
                .rotate((customsign(sigmat) + 1) / 2 * 180, arroworiginx, arroworiginy + arrowlength * 0.4 * r / 2)
                .rotate(-customsign(phi + 0.0000001) * 90 * signxz, arroworiginx, arroworiginy)
                .rotate((-phi - customsign(phi) * 90 + (signxz - 1) / 2 * 180), sigmax, -tauxz)
                .setColor(col.sk.getRgb())
                .setFill(col.sk.getRgba()));
        }

    }
    // if (math.abs(phi-math.round(principledir()*10)/10)>=0.01 && math.abs(taunt)>=0.005){

    if (phi - principledir() !== 0 && principledir() - 180 - phi !== 0 && principledir() - 90 - phi !== 0 && principledir() + 90 - phi !== 0 && principledir() + 180 - phi !== 0) {

        let sign = customsign(taunt);
        if (sign == 0) {
            sign = 1
        }
        let arroworigin = sign * (0.5 + gap);
        let arrowlength = math.abs(taunt) * maximumvaluesclae * arrow_length_scale + arrow_scale * arrow_head_length;
        let arroworientation = -(sign - 1) / 2 * 180;
        temp_ntElement.addElm(new Arrow(arroworigin, -arrowlength / 2, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi, 0, 0));
        temp_ntElement.addElm(new Arrow(arroworigin, -arrowlength / 2, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi + 180, 0, 0));

        arroworientation = (sign + 1) / 2 * 180;
        temp_ntElement.addElm(new Arrow(-arroworigin, -arrowlength / 2, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi + 90, 0, 0));
        temp_ntElement.addElm(new Arrow(-arroworigin, -arrowlength / 2, arrowlength, arroworientation, arrow_scale).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()).rotate(-phi + 270, 0, 0));

        if (phi - 0 !== 0) {
            // Mohr n-Element
            let arroworiginx = sigmax + customsign(tauxz) * gap * 0.4 * r;
            let arroworiginy = -tauxz + customsign(tauxz) * customsign(tauxz + taunt) * (d1 + 0.3 * r) - arrowlength * 0.4 * r / 2;
            temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginy, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r).rotate((customsign(tauxz) * customsign(taunt) - 1) / 2 * 180, arroworiginx, arroworiginy + arrowlength * 0.4 * r / 2).rotate(-phi + (customsign(tauxz) - 1) / 2 * 180, sigmax, -tauxz).setColor(col.sk.getRgb()).setFill(col.sk.getRgba()));

            // Mohr t-Element
            arroworiginx = sigmax + customsign(tauxz) * customsign(phi) * gap * 0.4 * r;
            arroworiginy = -tauxz + customsign(tauxz) * -customsign(tauxz - taunt) * (d2 + 0.3 * r) - arrowlength * 0.4 * r / 2;
            temp_Mohr.addElm(new Arrow(arroworiginx, arroworiginy, arrowlength * 0.4 * r, 0, arrow_scale * 0.4 * r)
                .rotate((customsign(taunt) * customsign(tauxz) * customsign(phi) + 1) / 2 * 180, arroworiginx, arroworiginy + arrowlength * 0.4 * r / 2)
                .rotate((-phi - customsign(phi) * 90 + (customsign(tauxz) - 1) / 2 * 180), sigmax, -tauxz)
                .setColor(col.base.getRgb())
                .setFill(col.sk.getRgba()));

        }

    }


    // Coordinate System
    temp_ntElement.addElm(new Arrow(0, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(-phi + 90, 0, 0));
    temp_ntElement.addElm(new Arrow(0, -0.4, 0.4, 0, arrow_scale * 0.5).setFill(col.base.getRgba()).rotate(-phi, 0, 0));
    if (phi == principledir()) {
        temp_ntElement.addElm(new Text(math.cos(-phi / 180 * math.pi) * 0.4 - math.sin(-phi / 180 * math.pi) * 0.1, math.sin(-phi / 180 * math.pi) * 0.4 + math.cos(-phi / 180 * math.pi) * 0.1, "1"));
        temp_ntElement.addElm(new Text(math.cos(-phi / 180 * math.pi) * 0.1 - math.sin(-phi / 180 * math.pi) * -0.4, math.sin(-phi / 180 * math.pi) * 0.1 + math.cos(-phi / 180 * math.pi) * -0.4, "3"));
        temp_ntElement.addElm(new Text(math.cos(-phi / 180 / 2 * math.pi) * 0.3 + 0.45, math.sin(-phi / 180 / 2 * math.pi) * 0.3, [" φ = φ<sub>1</sub> = " + phiround.toString() + "°"]));

    } else {
        temp_ntElement.addElm(new Text(math.cos(-phi / 180 * math.pi) * 0.4 - math.sin(-phi / 180 * math.pi) * 0.1, math.sin(-phi / 180 * math.pi) * 0.4 + math.cos(-phi / 180 * math.pi) * 0.1, "<i>n</i>"));
        temp_ntElement.addElm(new Text(math.cos(-phi / 180 * math.pi) * 0.1 - math.sin(-phi / 180 * math.pi) * -0.4, math.sin(-phi / 180 * math.pi) * 0.1 + math.cos(-phi / 180 * math.pi) * -0.4, "<i>t</i>"));
        temp_ntElement.addElm(new Text(math.cos(-phi / 180 / 2 * math.pi) * 0.3 + 0.3, math.sin(-phi / 180 / 2 * math.pi) * 0.3, [" φ = " + phiround.toString() + "°"]));
    }
    // Principal Angle
    temp_ntElement.addElm(new Circle(0, 0, 0.25, -phi));
    temp_ntElement.addElm(new Line([0, 0.4], [0, 0]).setDash('dot'));

    /*
    Layouts
     */
    let layout_Element = {
        hovermode: false,
        height: 350,

        margin: {
            l: 0,
            r: 0,
            b: 0,
            t: 0,
            pad: 0
        },
        xaxis: {
            domain: [0, 1],
            autorange: true,
            showgrid: false,
            zeroline: false,
            showline: false,
            autotick: true,
            ticks: '',
            showticklabels: false,
            range: [-1.5, 1.5],
        },
        yaxis: {
            domain: [0, 1],
            autorange: true,
            showgrid: false,
            zeroline: false,
            showline: false,
            autotick: true,
            ticks: '',
            showticklabels: false,
            scaleanchor: "x",
            scaleratio: 1,
            range: [-1.5, 1.5],



        },
        showlegend: false,
    };

    let layout_Mohr = {
        hovermode: 'closest',
        height: 350,

        margin: {
            l: 40,
            r: 20,
            b: 40,
            t: 10,
            pad: 0
        },
        xaxis: {
            title: 'σ [MPa]',
            domain: [0, 1],
            autorange: true,
            zeroline: true,
            autotick: true,
            range: [m - 2 * r, m + 2 * r],
        },
        yaxis: {
            title: 'τ [MPa]',
            domain: [0, 1],
            rangemode: 'tozero',
            autorange: true,
            zeroline: true,
            scaleanchor: "x",
            scaleratio: 1,
            range: [-1.5 * r, 1.5 * r],
        },
        showlegend: false,
    };



    // Plot XZ-Element
    let pltSec = temp_xzElement.getPlotData();
    var data = pltSec.data;
    Plotly.newPlot(plot_xzElement, data, layout_Element, { staticPlot: true, responsive: true, displaylogo: false });

    // Plot NT-ELement
    pltSec = temp_ntElement.getPlotData();
    data = pltSec.data;
    Plotly.newPlot(plot_ntElement, data, layout_Element, { staticPlot: true, responsive: true, displaylogo: false });

    // Plot Mohr Circle
    pltSec = temp_Mohr.getPlotData();
    data = pltSec.data;
    console.log(data)

    for (let i = 0; i < data.length; i++) {

        if (i == 0) {
            data[i].hovertemplate = "σ<sub><i>x</i></sub> = %{x:,.2f} MPa τ<sub><i>xz</i></sub> = %{y:,.2f} MPa";
        } else if (i == 1) {
            data[i].hovertemplate = "σ<sub><i>z</i></sub> = %{x:,.2f} MPa τ<sub><i>xz</i></sub> = " + math.round(tauxz * 100) / 100 + " MPa";
        } else if (i == 2 && phi - 0 !== 0) {
            data[i].hovertemplate = "σ<sub><i>n</i></sub> = %{x:,.2f} MPa τ<sub><i>nt</i></sub> = %{y:,.2f} MPa";
        } else if (i == 3 && phi - 0 !== 0) {
            data[i].hovertemplate = "σ<sub><i>t</i></sub> = %{x:,.2f} MPa τ<sub><i>nt</i></sub> = " + math.round(taunt * 100) / 100 + " MPa";
        } else if ((i == 5 && phi - 0 !== 0) || (i == 3 && phi - 0 == 0)) {
            data[i].hovertemplate = "Pol Q";
        }
        else {
            data[i].hoverinfo = 'none';
        }
    }


    Plotly.newPlot(plot_mohr, data, layout_Mohr, config);
    phi_princ = 0;
}

function tensortransform(x, z, xz, phi) {
    let c = math.cos(phi / 180 * math.pi);
    let s = math.sin(phi / 180 * math.pi);
    let n = c * c * x + s * s * z + 2 * s * c * xz;
    let t = s * s * x + c * c * z - 2 * s * c * xz;
    let nt = -s * c * x + s * c * z + (c * c - s * s) * xz;
    return [n, t, nt];
}

function principledir() {
    sigmax = parseFloat($("#sigmax").val());
    sigmaz = parseFloat($("#sigmaz").val());
    tauxz = parseFloat($("#tauxz").val());
    let twophi1 = math.atan2(tauxz, (sigmax - sigmaz) / 2);
    let phi1 = twophi1 / 2;
    phi1 = phi1 * 180 / math.pi;
    return phi1;
}

function customsign(a) {
    let b = math.sign(a);
    if (b == 0) {
        b = 1;
    }
    return b;
}


updateCalc();